// import { configureStore } from '@reduxjs/toolkit';
// import { persistReducer } from 'redux-persist';

// import rootReducer from './Rootreducer';

// const store = configureStore({
//     reducer: rootReducer,
// });

// export default store;

import { configureStore } from '@reduxjs/toolkit';
import { persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/es/storage'; // works for web
import rootReducer from './Rootreducer';

// Persist config
const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['auth'] // optional: only persist specific slices
};

// Persisted reducer
const persistedReducer = persistReducer(persistConfig, rootReducer);

// Create store
const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false, // required for redux-persist
    }),
});

export const persistor = persistStore(store);
export default store;
